import { ItemStatistics } from './item-statistics.type';

export class EdgeStatistics extends ItemStatistics {
  transfersCount: number;
}
